// extracted by mini-css-extract-plugin
export var active = "bG_bd";
export var categories = "bG_c1";
export var category = "bG_c2";
export var description = "bG_dx";
export var featured = "bG_c5";
export var icon = "bG_bq";
export var input = "bG_bp";
export var mobileVidContainer = "bG_hy";
export var mobileVideo = "bG_hz";
export var mobileVideoThumbnail = "bG_hB";
export var mobileVideoTitle = "bG_hC";
export var mobileVidsContainer = "bG_hx";
export var moreVideo = "bG_hs";
export var moreVideoContainer = "bG_hr";
export var moreVideoThumbnail = "bG_ht";
export var moreVideoTitle = "bG_hv";
export var moreVideos = "bG_hj";
export var moreVideosHeader = "bG_hh";
export var moreVideosSlider = "bG_hq";
export var moreVideosSliderMobile = "bG_hp";
export var scrollArrow = "bG_hl";
export var scrollButton = "bG_hk";
export var scrollLeft = "bG_hm";
export var scrollRight = "bG_hn";
export var search = "bG_bn";
export var section = "bG_d";
export var sectionTitle = "bG_hg";
export var selector = "bG_hw";
export var selectors = "bG_dR";
export var video = "bG_gY";
export var videoContainer = "bG_hf";